import { FirebaseApp, initializeApp } from "firebase/app";
import { Messaging, getMessaging, getToken, onMessage, deleteToken } from "firebase/messaging";
import { useEffect, useState } from "react";

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};

export const useFirebase = () => {
  const [app, setApp] = useState<FirebaseApp>();
  const [messaging, setMessaging] = useState<Messaging>();
  const [notificationPermissionStatus, setNotificationPermissionStatus] = useState("");

  useEffect(() => {
    setApp(initializeApp(firebaseConfig));
    setMessaging(getMessaging(app));
    getFCMToken();
  }, []);

  async function getFCMToken() {
    if (!messaging) return undefined;

    const status = await Notification.requestPermission();
    setNotificationPermissionStatus(status);

    if (status && status === "granted") {
      try {
        const token = await getToken(messaging, {
          vapidKey: process.env.NEXT_PUBLIC_VAPID_KEY,
        });

        onMessage(messaging, (payload) => {
          new Notification(payload.notification!.title!, {
            body: payload.notification!.body,
            icon: payload.notification?.icon ?? "/icons/favicon-72x72.png",
          });
        });

        localStorage.setItem("firebase-push-token", token);

        return token;
      } catch (e) {
        console.log("getFCMToken error", e);
        return undefined;
      }
    }
  }

  async function deleteFCMToken() {
    if (messaging) {
      await deleteToken(messaging);
      localStorage.removeItem("firebase-push-token");
      return true;
    }

    return false;
  }

  return { getFCMToken, deleteFCMToken, notificationPermissionStatus, app, messaging };
};
